export default {"src":"/_next/static/media/download_w.a6a1ae28.svg","height":512,"width":512};